import { FC, createContext, useContext, useState, ReactNode } from 'react';

interface MasterDataContextType {
    isLoading: boolean;
    setIsLoading: (isLoading: boolean) => void;
}

const MasterDataContext = createContext<MasterDataContextType | undefined>(undefined);

export const MasterDataProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    return (
        <MasterDataContext.Provider
            value={{
                isLoading,
                setIsLoading,
            }}
        >
            {children}
        </MasterDataContext.Provider>
    );
};

export const useMasterData = () => {
    const context = useContext(MasterDataContext);
    if (!context) {
        throw new Error('useMasterDataContext must be used within a MasterDataProvider');
    }
    return context;
};
